import { API_HOST } from '@/utils/connections/endpoints';
import { BLAuth } from '@brandlive/client-auth';
import { getFromAppConfigForCurrentLocation } from '@/utils/get-from-app-config-for-current-location';

const fromAppConfig = getFromAppConfigForCurrentLocation();

export default new BLAuth(API_HOST, import.meta.env.VITE_LOGIN_HOST as string, false, fromAppConfig);
